<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :changelog="changelog" />


    <v-container class="section-block">
        <v-row>
            <v-col class="col-12 col-md-4 col-sm-4">
                <h3>Workflow</h3>
                <ol>
                    <li>Create ↔/↕ rules</li>
                    <li>Create boxes</li>
                    <li>Constrain boxes to comp edges and rules</li>
                    <li>(optional) Create a metrics control and adjust padding globally</li>
                    <li>(optional) Link precomps of assets to boxes</li>
                    <li>** Animate a responsive grid and don't tell folks how quick you did it</li>
                </ol>
            </v-col>
            <v-col class="col-12 col-md-8 col-sm-8">
                <video width="100%" :src="video.tutorial" controls></video>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-12 col-md-4 col-sm-5">
                <img :src="images.ui" width="100%" alt="">
            </v-col>
            <v-col class="col-12 col-md-6 col-sm-6">
                <h3>Controls</h3>
                <ul>
                    <li><b>Metrics:</b> One layer to control the global padding and box corner rounding within a comp.</li>
                    <li><b>↔/↕ rules:</b> Keyframable edges that act as constraints for boxes.</li>
                </ul>

                <br/>
                <h3>Assets</h3>
                <ul>
                    <li><b>Boxes:</b> The basic responsive unit that is resized by dragging rules. 
                    Parent shapes/text/images to boxes and use them as mattes.</li>
                    <li><b>Link precomp:</b> Select a precomp and click to select an available box. 
                    Parenting, matting and expressions to resize intuitivly keeping the image within view (like in Figma).</li>
                </ul>

                <br/>
                <h3>Box Constraints</h3>
                <p>
                    Each box may be constrained to a comp edge or ↔/↕ rule. 
                    Select the top, bottom, left, and right edges and <b>Apply</b>.
                    Click <b>⟳</b> to refresh dropdowns for newly created rules
                </p>
            </v-col>
        </v-row>
    </v-container>

    <InstallInfo id="install" name="Radness" scriptUI :hosts="['After Effects']"/>
    <Changelog :changelog="changelog" /> 
    
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'conclave',
  components: {
  },
  data: () => ({
      projectInfo: {
          name: 'Flugridity',
          subtitle: 'Dynamic box resizing in Ae',
          source: true,
          about: `Built to solve one if the areas code does quickly but Ae cannot, <b>Flugridity</b> creates a responsive grid system that resizes based on the dragging of edges.`
      },
      images: {
            ui: require('../assets/images/Flugridity.jpg'),
        },
        video: {
            tutorial: require('../assets/video/Flugridity_01.mp4'),
        },
      changelog: [
            {
                version: '0.1.2',
                date: 'Mar 4, 2021',
                changed: [
                    'Legacy expression support',
                ],
            },
            {
                version: '0.1.1',
                date: 'Jan 04, 2021',
                changed: [
                    'UI tweaks and updates',
                ],
            },
            {
                version: '0.1.0',
                date: 'Dec 16, 2020',
                comment: ['Initial release'],
            },
        ]
  }),
}
</script>